import { create } from 'zustand';

interface KeyboardLayoutState {
  version: number;
  bump: () => void;
}

export const useKeyboardLayoutStore = create<KeyboardLayoutState>((set) => ({
  version: 0,
  bump: () => set((s) => ({ version: s.version + 1 })),
}));
